import { render, staticRenderFns } from "./EfsCapCostModal.vue?vue&type=template&id=530a1d72&scoped=true&"
import script from "./EfsCapCostModal.vue?vue&type=script&lang=js&"
export * from "./EfsCapCostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a1d72",
  null
  
)

export default component.exports